<template>
    <div class="adjustPageOne">
        <div class="box" @click="toAdjust">
          <div class="btn"></div>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "adjustPageOne",
    data() {
      return {
        campaignid: '',
        adgroupid: '',
        keyword: '',
        gclid: '',
        gbraid: '',
        wbraid: '',
      };
    },
    created() {
      const { campaignid, adgroupid, keyword, gclid, gbraid, wbraid } = this.$route.query;
      this.campaignid = campaignid || 0;
      this.adgroupid = adgroupid || 0;
      this.keyword = keyword || 0;
      this.gclid = gclid || 0;
      this.gbraid = gbraid || 0;
      this.wbraid = wbraid || 0;
    },
    mounted() {
    },
    methods: { 
      toAdjust(){
        window.location.href = `https://app.adjust.com/1gntu7x9?campaign=${this.campaignid}&adgroup=${this.adgroupid}&creative=${this.keyword}&gclid=${this.gclid}&gbraid=${this.gbraid}&wbraid=${this.wbraid}`
      }
    },
  };
  </script>
  
  <style scoped>
  .adjustPageOne{
    width: 100vw;
  padding-bottom: 80px;
  }
  .box{
    margin-top: 24px;
    width: 100%;
    height: 3036px;
    background: url('../../assets/adjustPage/oneBg.png') no-repeat;
    background-size: 100% 100%;
  }
  .btn{
    width: 503px;
    height: 164px;
    background: url('../../assets/adjustPage/downloadBtn.png') no-repeat;
    background-size: 100% 100%;
    position: fixed;
    left: 50%;
    bottom: 32px;
    transform: translateX(-50%);
  }
  </style>
  